// Import utilities
import { recipeHasConditions } from '@builder-legacy/item/conditions/utilities';

/**
 * Returns an array with the conditions in the recipe using the format expected by the backend
 *
 * @return {Array} The conditions
 */
const sanitizeConditionsForMeta = () => {
	// Default return
	const conditions = [];

	// Check if there are conditions in the recipe
	if ( recipeHasConditions() ) {
		// Iterate conditions
		// eslint-disable-next-line no-unused-vars
		Object.entries( UncannyAutomator.recipe.conditions ).forEach( ( [ conditionsGroupId, conditionsGroup ] ) => {
			if (
				// DON'T save group of conditions without conditions
				conditionsGroup.hasConditions
			) {
				// Add the sanitized data
				conditions.push( conditionsGroup.formattedForMeta );
			}
		} );
	}

	return conditions;
};

export default sanitizeConditionsForMeta;
